import React from 'react';
import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import { GoTopBtn } from '../components/GoTopBtn';
import './Supports.css';

import { SuppSensorSS } from "../assets/SupportsData";
import { SuppSensorSM } from "../assets/SupportsData";
import { SuppSensorMM } from "../assets/SupportsData";
import { SuppSensorML } from "../assets/SupportsData";
import { SuppSensorLL } from "../assets/SupportsData";
import { SuppSensorXL } from "../assets/SupportsData";

import SuppSensorSSImg from '../images/SupportImg/SuppSensorSS.jpg';
import SuppSensorSMImg from '../images/SupportImg/SuppSensorSM.jpg';
import SuppSensorMMImg from '../images/SupportImg/SuppSensorMM.jpg';
import SuppSensorMLImg from '../images/SupportImg/SuppSensorML.jpg';
import SuppSensorLLImg from '../images/SupportImg/SuppSensorLL.jpg';
import SuppSensorXLImg from '../images/SupportImg/SuppSensorXL.jpg';

function SupportSensor() {
  // console.log("get into SupportSensor()");
  return (
    <div className='supportsensor-page'>
      <header className='mt-5'>
        <Container className='h-100 d-flex align-items-center justify-content-center'>
          {/* <div className='container h-100 d-flex align-items-top justify-content-center'> */}
          <h1 className='text-light'>Support / Sensor</h1>
        </Container>
      </header>

      <section id='suppsensorss' className='suppsensor bg-info-subtle text-dark my-4'>
        {/* <section id='suppsssensor' className='block support-block suppsensor bg-primary-subtle text-dark my-4'> */}
        <Container>
          {/* <h2 className='title-holder fs-1 mb-4 mb-lg-5 fw-bold text-primary'>Small Size</h2> */}
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Small Size Sensor</h2>
          <Row>
            {/* <Row className='row flex-column-reverse flex-lg-row'> */}
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '85vh' }} src={SuppSensorSSImg} className='mt-5 mt-lg-0' alt="" />
              {/* <img style={{ height: '80vh' }} src={SuppSensor} className='img-fluid w-80 mt-4 mt-lg-0' alt="" /> */}
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {/* <Col className='col-lg-6 d-flex flex-column justify-content-around'> */}
              {SuppSensorSS.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {sensor.name} </CardTitle>
                      {/* <CardTitle className='fs-2 text-success p-1 mx-2'> {sensor.name} </CardTitle> */}
                      <CardText className='fs-4'>
                        {/* <CardText className='text-center fs-4'> */}
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section >

      <section id='suppsensorsm' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Small-Miduim Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppSensorSM.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {sensor.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppSensorSMImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section >

      <section id='suppsensormm' className='suppsensor bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Miduim Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '75vh' }} src={SuppSensorMMImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppSensorMM.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {sensor.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section >

      <section id='suppsensorml' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Miduim-Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppSensorML.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {sensor.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '85vh' }} src={SuppSensorMLImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section >

      <section id='suppsensorll' className='suppsensor bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support/Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '75vh' }} src={SuppSensorLLImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppSensorLL.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-primary px-3 my-1'> {sensor.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
          </Row>
        </Container>
      </section >

      <section id='suppsensorxl' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support/Extra-Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'>
              {SuppSensorXL.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <CardBody className='d-flex justify-content-center'>
                      <CardTitle className='fs-2 text-success px-3 my-1'> {sensor.name} </CardTitle>
                      <CardText className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </CardText>
                    </CardBody>
                  </Card>
                </Row>
              ))}
            </Col>
            <Col lg={6} className='d-flex justify-content-center'>
              <img style={{ height: '60vh' }} src={SuppSensorXLImg} className='mt-5 mt-lg-0' alt="" />
            </Col>
          </Row>
        </Container>
      </section >
      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default SupportSensor;